
import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { NzModalService } from 'ng-zorro-antd/modal';
import { ModalConfirmWithInputComponent } from 'src/shared/components/confirm-input-modal/confirm-input-modal';
import { ModalConfirmComponent } from 'src/shared/components/confirm-modal/confirm-modal';

@Injectable({providedIn: 'root'})
export class DialogService {
    constructor(
        private modal: NzModalService,
        private translate: TranslateService) {
    }

    confirm(
        title: string,
        message: string,
        ok: () => void,
        options?: {
            submit_color?: string;
            confirmLabel?: string;
            cancelLabel?: string;
        }
    ) {
        const modal = this.modal.create({
            nzTitle: this.translate.instant(title),
            nzContent: ModalConfirmComponent,
            nzFooter: null,
            nzData: {
                message,
                submit_color: options?.submit_color,
                confirmLabel: options?.confirmLabel,
                cancelLabel: options?.cancelLabel,
            }
        });
        modal.afterClose.subscribe(result => {
            if (result === 'yes') {
                ok();
            }
        });
    }

    confirmReject(title, message, ok) {
        const modal = this.modal.create({
            nzTitle: this.translate.instant(title),
            nzContent: ModalConfirmWithInputComponent,
            nzFooter: null,
            nzData: {
                message
            }
        });
        modal.afterClose.subscribe(result => {
            if (result) {
                ok(result);
            }
        });
    }
}
